import React from "react";
import { Alert, Stack, Typography } from "@mui/material";

const AdminForbiddenPage = () => {
  return (
    <Stack spacing={2}>
      <Typography variant='h4'>403 Forbidden</Typography>
      <Alert severity='warning'>
        You are authenticated but do not have permission to access admin pages.
      </Alert>
    </Stack>
  );
};

export default AdminForbiddenPage;
